import type { ComponentProps } from 'react'
import { IconButton } from 'react-native-paper'
import { withUnistyles } from 'react-native-unistyles'

import { Theme, ThemeColorName } from '@/styles/theme'

const BaseIconButton = withUnistyles(IconButton)

type BaseIconButtonProps = ComponentProps<typeof IconButton>
type ThemedIconButtonProps = Omit<BaseIconButtonProps, 'key'>

export type UniIconButtonProps = BaseIconButtonProps & {
  iconColorName?: ThemeColorName
  rippleColorName?: ThemeColorName
  getThemeProps?: (theme: Theme) => Partial<ThemedIconButtonProps>
}

const UniIconButton = ({
  iconColor,
  iconColorName,
  rippleColor,
  rippleColorName,
  getThemeProps,
  ...rest
}: UniIconButtonProps) => {
  return (
    <BaseIconButton
      {...rest}
      iconColor={iconColor}
      rippleColor={rippleColor}
      uniProps={(theme) => ({
        ...(iconColor || !iconColorName
          ? {}
          : { iconColor: theme.colors[iconColorName] }),
        ...(rippleColor || !rippleColorName
          ? {}
          : { rippleColor: theme.colors[rippleColorName] }),
        ...getThemeProps?.(theme),
      })}
    />
  )
}

export default UniIconButton
